import { useIntl } from 'react-intl'
import styled from 'styled-components'
import DatePickerISO from 'ui/components/DatePickerISO'
import type { LoanViewFilters } from '../types'

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 16px;
	margin-bottom: 16px;
`

const Filter = styled.div`
	min-width: 160px;
`

type Props = {
	filters: LoanViewFilters
	setFilters: React.Dispatch<React.SetStateAction<LoanViewFilters>>
}

function ShareCalculationFilters({ filters, setFilters }: Props) {
	const intl = useIntl()

	return (
		<Container>
			<Filter>
				<DatePickerISO
					id="loan-share-calculation-start-date-filter"
					label={intl.formatMessage({
						defaultMessage: 'Alkupäivä',
						description:
							'Label for the loan share calculation start date filter.',
					})}
					value={filters.startDate || ''}
					onChange={(isoDate: string) => {
						setFilters((prev) => ({ ...prev, startDate: isoDate }))
					}}
				/>
			</Filter>
			<Filter>
				<DatePickerISO
					id="loan-share-calculation-end-date-filter"
					label={intl.formatMessage({
						defaultMessage: 'Loppupäivä',
						description:
							'Label for the loan share calculation end date filter.',
					})}
					value={filters.endDate || ''}
					onChange={(isoDate: string) => {
						setFilters((prev) => ({ ...prev, endDate: isoDate }))
					}}
				/>
			</Filter>
		</Container>
	)
}

export default ShareCalculationFilters
